export const LAST_REACT_STOREFRONT_PAGE = 'lastReactStorefrontPage';
export const REACT_STOREFRONT_HISTORY = 'reactStorefrontHistory';
